<script setup>
import { init } from '@weathernews/btos-javascript-modules/src/wniutil/init.js'

onMounted(() => {
  init()
})
</script>

<template>
  <NuxtPage />
</template>
